import React from "react";
import { Icon } from "@evidenceb/athena-common/design-system/Icon";

import "./Select.scss";

import { VisuallyHidden } from "@evidenceb/athena-common/ui/VisuallyHidden";
import { formatTxtToSlug } from "../../utils/format";

interface Props {
    onSelectOption: (value: string) => void;
    selectedOption: string | React.ReactNode | (string | React.ReactNode)[];
    label?: string;
    visibleLabel?: boolean;
    children: React.ReactNode;
    className?: string;
}

/**
 * Select component using native select functionalities but adding custom
 * styles.
 * Children should be the various options.
 */
const Select = ({
    selectedOption,
    onSelectOption,
    label,
    visibleLabel = false,
    children,
    className,
}: Props) => {
    const labelId = label && `${formatTxtToSlug(label)}`;

    return (
        <div className={`select ${className ?? ""}`}>
            {!visibleLabel && (
                <VisuallyHidden>
                    <label htmlFor={labelId}>{label}</label>
                </VisuallyHidden>
            )}
            <select
                id={labelId}
                name={labelId}
                aria-labelledby={labelId}
                className="select__native-select"
                onChange={(e) => {
                    onSelectOption(e.target.value);
                }}
            >
                {children}
            </select>

            <div className="select__visual-select">
                {visibleLabel && label && (
                    <label htmlFor={labelId} id={labelId}>
                        {label}
                    </label>
                )}
                <div className="select__visual-select__wrapper">
                    <div className="option">{selectedOption}</div>
                    <div className="visual-select__drop-icon">
                        <Icon
                            path="chevron_down"
                            size="medium"
                            // color={"var(--text-main-default)"}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Select;
